import { EntityMetaData, FieldType } from "@gbs-platform-client/fwk-core";

export class EntityDto
{
    EntityMetaData: Array<EntityMetaData>;

    constructor() {
        this.EntityMetaData = []
    }
}

export interface IEntityDto
{

}